module.exports = __webpack_public_path__ + "static/media/liked.136fd7d5.svg";